// extracted by mini-css-extract-plugin
module.exports = {"LPPage":"Frontend_LPPage__30Oha","contents":"Frontend_contents__1TGyf"};